import { NgModule } from "@angular/core"
import { BrandSliderContainer } from "./brand-slider-container.component"
import {CommonModule} from '@angular/common'
import { AdBannerModule } from "./ad-banner/ad-banner.module"
import { SubscriptionReviewComponent } from './subscription-review/subscription-review.component'
import { PopoverModule } from "ngx-bootstrap/popover"

@NgModule({
  imports: [
    CommonModule,
    AdBannerModule,
    PopoverModule
  ],
  declarations: [
    BrandSliderContainer,
    SubscriptionReviewComponent
  ],
  exports: [
    BrandSliderContainer,
    AdBannerModule,
    SubscriptionReviewComponent
  ]
})
export class SharedModule {}
